import React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../../lib/utils';
import NavItem from './NavItem';

const NavGroup = ({ id, icon, label, expandedMap, toggleExpand, childrenItems = [], isActiveParent, open = true, currentPath, rightElement, badges = {} }) => {
  const isExpanded = !!expandedMap[id];

  return (
    <div>
      <button
        onClick={() => toggleExpand(id)}
        className={cn(
          "flex items-center justify-between w-full px-3 py-2 rounded-lg text-sm font-medium transition-colors",
          isActiveParent || isExpanded ? "bg-white/10 text-white" : "text-gray-400 hover:text-white hover:bg-white/5"
        )}
      >
        <div className={cn("flex items-center", open ? "gap-3" : "justify-center w-full")}>
          <span className="h-5 w-5 flex items-center justify-center flex-shrink-0">{icon}</span>
          {open && label}
        </div>
        {!open ? null : rightElement ? (
          rightElement
        ) : (
          <ChevronDown className={cn("h-4 w-4 transition-transform", isExpanded && "rotate-180")} />
        )}
      </button>

      {isExpanded && (
        <div className="mt-1 ml-3 pl-3 border-l border-white/10 space-y-0.5">
          {childrenItems.map((child) => {
            const isActive = currentPath === child.url || (child.url !== '/' && currentPath.startsWith(child.url + '/'));
            const badge = badges[child.name] || badges[child.navName] || 0;
            return (
              <NavItem
                key={child.id}
                to={child.url}
                icon={child.icon && React.cloneElement(child.icon, { className: 'h-4 w-4' })}
                label={child.navName || child.name}
                isActive={isActive}
                open={open}
                badge={badge}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default NavGroup;
